const selector = {
    methods: {
        select: function( selector )
        {
            var elems;
            if( selector === 'document' )
            {
                elems = [document];
            }
            else if( selector === 'window' )
            {
                elems = [window];
            }
            else
            {
                elems = document.querySelectorAll(selector);
            }

            if( elems.length == 1 )
                return elems[0]
            else
                return elems;
        }
    }
}

export default selector;